import { CategoryService } from "../../shared/services";

class CategoryServiceWrapper {
  public categoryService: CategoryService;
  constructor() {
    this.categoryService = new CategoryService();
  }
}

const CategoryServiceStore = new CategoryServiceWrapper();
export default CategoryServiceStore;
